import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RejectionStatusCd from 'domain/enums/RejectionStatusCd';
import RejectionTypeCd from 'domain/enums/RejectionTypeCd';
import RejectionReason from 'domain/types/RejectionReason';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface IActions {
  shouldResubmit: boolean;
  shouldReuploadID: boolean;
  shouldResuploadPrimaryResidence: boolean;
  shouldResuploadPrimaryResidence2: boolean;
  shouldSubmitShuol: boolean;
  shouldCheckout: boolean;
  onCheckout: () => void;
  hasCityDebt: boolean;
  isRevoked: boolean;
  groupRefKey: string;
  isInCart: boolean;
  onRemoveFromCart: () => void;
  rejections: RejectionReason[];
  isRegistrationAction: boolean;
  canRequestRenewal: boolean;
}

const Actions = (props: IActions) => {
  const getRejLinkText = (typeCd: RejectionTypeCd) =>
    props.rejections
      .filter(
        (r) =>
          r.typeCd === typeCd && r.statusCd === RejectionStatusCd.NOT_RESOLVED
      )
      .map((r) => r.descr)
      .join(', ');

  const controller = 'application-group';
  return (
    <>
      {props.shouldResubmit && (
        <div>
          <Link to={`/${controller}/${props.groupRefKey}`}>
            Resubmit Application
          </Link>
        </div>
      )}
      {props.canRequestRenewal && (
        <div>
          <Link to={`/renew-registration/${props.groupRefKey}`}>
            Request Renewal
          </Link>
        </div>
      )}
      {props.shouldReuploadID && (
        <div>
          <Link
            to={{
              pathname: '/profile',
              hash: 'identity-verification',
              state: {
                onReupload: {
                  to: `/${controller}/${props.groupRefKey}`,
                  message: 'Identification docs have been uploaded.',
                  linkText: 'Navigate to application to resubmit.',
                },
              },
            }}
          >
            {/* Resubmit Identification */}
            {getRejLinkText(RejectionTypeCd.IDENTITY)}
          </Link>
        </div>
      )}
      {props.shouldResuploadPrimaryResidence && (
        <div>
          <Link to={`/${controller}/${props.groupRefKey}`}>
            {/* Resubmit Primary Residence - Document 1*/}
            {getRejLinkText(RejectionTypeCd.PRIMARY_RESIDENCE)}
          </Link>
        </div>
      )}
      {props.shouldResuploadPrimaryResidence2 && (
        <div>
          <Link to={`/${controller}/${props.groupRefKey}`}>
            {/* Resubmit Primary Residence - Document 2 */}
            {getRejLinkText(RejectionTypeCd.PRIMARY_RESIDENCE_02)}
          </Link>
        </div>
      )}
      {props.shouldSubmitShuol && (
        <div>
          <Link
            to={{
              pathname: '/profile',
              hash: 'shuol',
              state: {
                onSuccess: {
                  to: `/${controller}/${props.groupRefKey}`,
                  message: 'SHUOL has been updated.',
                  linkText: 'Navigate to application to resubmit.',
                },
              },
            }}
          >
            {/* Add SHUOL */}
            {getRejLinkText(RejectionTypeCd.SHUOL)}
          </Link>
        </div>
      )}
      {props.shouldCheckout && (
        <div>
          <Button
            style={{ whiteSpace: 'nowrap' }}
            type='button'
            onClick={props.onCheckout}
          >
            Add to cart
          </Button>
        </div>
      )}
      {props.isInCart && <div>Added to Cart</div>}
      {/* Alternative to above, show remove from cart instead*/}
      {/*{props.isInCart && (*/}
      {/*  <div>*/}
      {/*    <Button*/}
      {/*      type='button'*/}
      {/*      variant='link'*/}
      {/*      onClick={props.onRemoveFromCart}*/}
      {/*      className='px-0 py-0'*/}
      {/*    >*/}
      {/*      Remove from Cart*/}
      {/*    </Button>*/}
      {/*  </div>*/}
      {/*)}*/}
      {props.hasCityDebt && (
        <div className='text-nowrap'>
          <Link to='/static-pages/contact'>
            {/* City Debt */}
            {getRejLinkText(RejectionTypeCd.CITY_DEBT)}
          </Link>
          <OverlayTrigger
            overlay={
              <Tooltip id='city-debt' style={{ backgroundColor: '#fff' }}>
                Please contact the city to resolve this.
                {/* Sorry people, I also wish I knew how to resolve this... */}
              </Tooltip>
            }
          >
            <FontAwesomeIcon className='ml-2' icon={faInfoCircle} />
          </OverlayTrigger>
        </div>
      )}
      {props.isRevoked && (
        <div className='text-nowrap'>
          <Link to='/static-pages/contact'>
            {/* Previously Revoked */}
            {getRejLinkText(RejectionTypeCd.REVOKED)}
          </Link>
          <OverlayTrigger
            overlay={
              <Tooltip id='city-debt' style={{ backgroundColor: '#fff' }}>
                Please contact BACP with questions.
              </Tooltip>
            }
          >
            <FontAwesomeIcon className='ml-2' icon={faInfoCircle} />
          </OverlayTrigger>
        </div>
      )}
    </>
  );
};

export default Actions;
